import type { ReactNode } from "react";

interface MobileHeaderProps {
  title: string;
  leftAction?: ReactNode;
  rightAction?: ReactNode;
}

export function MobileHeader({ title, leftAction, rightAction }: MobileHeaderProps) {
  return (
    <header className="flex h-12 items-center justify-between border-b border-surface-3/50 bg-surface-0/80 px-4 backdrop-blur-xl dark:border-surface-dark-3/50 dark:bg-surface-dark-0/80 md:hidden">
      <div className="flex items-center gap-2">
        {leftAction}
      </div>
      <h1 className="text-base font-semibold">{title}</h1>
      <div className="flex items-center gap-2">
        {rightAction}
      </div>
    </header>
  );
}
